define('common/container/CommonContainer',[
    'jquery',
    'container/Container',
    'container/moduleLoaders/AmdModuleLoader',
    'container/moduleLoaders/FactoryServiceLoader',
    'container/moduleLoaders/StructuredArgLoader',
    'container/argResolvers/ContainerArgResolver',
    'container/argResolvers/CommandArgResolver',
    'container/argResolvers/CookieAccessorArgResolver',
    'container/argResolvers/ParamArgResolver',
    'container/argResolvers/QueryArgResolver',
    'container/argResolvers/DeferredServiceArgResolver',
    'container/argResolvers/ServiceArgResolver',
    'container/argResolvers/LoggerArgResolver',
    'container/argResolvers/WPArgResolver',
    'container/argResolvers/WPFieldEvaluatorArgResolver',
    'container/initialisers/ConstructorInitialiser',
    'container/initialisers/FactoryInitialiser',
    'container/initialisers/PartialInitialiser',
    'container/initialisers/ReturnInitialiser',
    'container/extensions/PubSubExtension',
    'container/extensions/SubscriptionManagerExtension',
    'common/container/CometdExtension'
], function (
    $,
    Container,
    AmdModuleLoader,
    FactoryServiceLoader,
    StructuredArgLoader,
    ContainerArgResolver,
    CommandArgResolver,
    CookieAccessorArgResolver,
    ParamArgResolver,
    QueryArgResolver,
    DeferredServiceArgResolver,
    ServiceArgResolver,
    LoggerArgResolver,
    WPArgResolver,
    WPFieldEvaluatorArgResolver,
    ConstructorInitialiser,
    FactoryInitialiser,
    PartialInitialiser,
    ReturnInitialiser,
    PubSubExtension,
    SubscriptionManagerExtension,
    CometdExtension
) {

    /**
     * A pre-configured container with all common extensions and params
     */
    function CommonContainer(extensions, config, handshake) {

        var wpArgResolver = new WPArgResolver('wp');

        Container.call(
            this,
            extensions.concat([
                new FactoryServiceLoader(),
                new AmdModuleLoader(),
                new StructuredArgLoader(),
                new CommandArgResolver('Command', 'PlatformCommandDispatcher', 'PlatformCmd'),
                new ContainerArgResolver(),
                new CookieAccessorArgResolver('createCookieAccessor', 'Logger'),
                new DeferredServiceArgResolver(),
                new LoggerArgResolver('Logger'),
                new ParamArgResolver(),
                new PubSubExtension('durandal/app'),
                new SubscriptionManagerExtension(),
                new CometdExtension('cometd'),
                new QueryArgResolver('Query'),
                new ServiceArgResolver(),
                wpArgResolver,
                new WPFieldEvaluatorArgResolver('evaluateDynamicText', wpArgResolver, 'Logger'),
                new FactoryInitialiser(),
                new PartialInitialiser(),
                new ReturnInitialiser(),
                Container.defaultInitialiser(new ConstructorInitialiser())
            ]),
            $.extend(true, config, {
                params: {
                    cms: {
                        hashes: fromHandshake('wpInterface', {}),
                        overrides: fromHandshake('wpInterface', {}).contentOverrides || {}
                    },
                    cometUrl: fromHandshake('context', {}).cometUrl,
                    contextConfiguration: fromHandshake('context', {}),
                    googleTagManagerId: fromHandshake('googleTagManager', {}).containerId,
                    mixPanelToken: fromHandshake('mixPanel', {}).token,
                    piqConfig: fromHandshake('piqConfig', {}),
                    preLoadedPlayers: fromHandshake('players', {}).players || {},
                    sessionState: fromHandshake('session', {}),
                    versionedLevelPoints: fromHandshake('Adventure', [])
                }
            })
        );

        function fromHandshake(name, fallback) {
            return handshake['common/composition/' + name] || fallback;
        }

    }

    CommonContainer.prototype = Object.create(Container.prototype);

    return CommonContainer;

});


